import { render } from "./vital-sign-button-js.vue?vue&type=template&id=26f2ad02&scoped=true"
import script from "./vital-sign-button-js.vue?vue&type=script&lang=js"
export * from "./vital-sign-button-js.vue?vue&type=script&lang=js"

import "./vital-sign-button-js.vue?vue&type=style&index=0&id=26f2ad02&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/hkust-gz-vitals/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26f2ad02"]])

export default __exports__